import { render, staticRenderFns } from "./lifeInsurance.vue?vue&type=template&id=297679f9&scoped=true"
import script from "./lifeInsurance.vue?vue&type=script&lang=js"
export * from "./lifeInsurance.vue?vue&type=script&lang=js"
import style0 from "./lifeInsurance.vue?vue&type=style&index=0&id=297679f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297679f9",
  null
  
)

export default component.exports